// src/app/router-helpers.js
import { ROLES, ACCOUNT_STATUS, PATHS, MEMBER_PROGRESS } from "./constants";

const norm = (u = {}) => ({
  role: String(u.role || "").toLowerCase(),
  status: String(u.status || "").toLowerCase(),

  // Member extras
  has_member: !!u.has_member,
  members_status: String(u.members_status || "").toLowerCase(),
  citizenship_selected: Boolean(u.citizenship_selected),

  // 🆕 email verification (support multiple shapes)
  email_verified:
    !!u.email_verified || !!u.emailVerified || !!u.emailVerifiedAt,
});

export function getLandingPath(user) {
  if (!user) return PATHS.LOGIN;

  const {
    role,
    status,
    has_member,
    members_status,
    citizenship_selected,
    email_verified,
  } = norm(user);

  // 🛑 If email isn’t verified, always send to verify page first
  if (!email_verified) return PATHS.VERIFY_EMAIL;

  // 1) Account status
  const accStatus = status || ACCOUNT_STATUS.ACTIVE;
  if (accStatus === ACCOUNT_STATUS.SUSPENDED) return PATHS.ACCOUNT_SUSPENDED;
  if (accStatus === ACCOUNT_STATUS.BANNED) return PATHS.ACCOUNT_BANNED;
  if (accStatus === ACCOUNT_STATUS.DELETED) return PATHS.ACCOUNT_DELETED;

  // 2) Role
  if (role === ROLES.ADMIN) return PATHS.ADMIN_HOME;
  if (role === ROLES.EDITOR) return PATHS.EDITOR_HOME;

  // 3) Member flow
  if (role === ROLES.MEMBER) {
    if (!has_member) return PATHS.MEMBER_CHOOSE_TYPE;

    // Approved members should always land in lounge, even if old records
    // are missing citizenship metadata.
    if (members_status === MEMBER_PROGRESS.APPROVED) return PATHS.APPROVED;

    if (!citizenship_selected) return PATHS.MEMBER_CHOOSE_TYPE;
    switch (members_status) {
      case MEMBER_PROGRESS.LOCAL:
        return PATHS.MEMBER_LOCAL;
      case MEMBER_PROGRESS.AVATAR:
        return PATHS.MEMBER_AVATAR;
      case MEMBER_PROGRESS.GENDER:
        return PATHS.MEMBER_GENDER;
      case MEMBER_PROGRESS.RELATION:
        return PATHS.MEMBER_RELATION;
      case MEMBER_PROGRESS.SEXUAL_IDENTITY:
        return PATHS.SEXUAL_IDENTITY;
      case MEMBER_PROGRESS.SEXUAL_ROLE:
        return PATHS.SEXUAL_ROLE;
      case MEMBER_PROGRESS.ATTRACTION_GENDERS:
        return PATHS.ATTRACTION_GENDERS;
      case MEMBER_PROGRESS.CONNECTION_TYPES:
        return PATHS.CONNECTION_TYPES;
      case MEMBER_PROGRESS.INTIMACY_TYPES:
        return PATHS.INTIMACY_TYPES;
      case MEMBER_PROGRESS.SEXUAL_FANTASIES:
        return PATHS.SEXUAL_FANTASIES;
      case MEMBER_PROGRESS.BODY_TYPE:
        return PATHS.BODY_TYPE;
      case MEMBER_PROGRESS.BODY_ATTRACT:
        return PATHS.BODY_ATTRACT;
      case MEMBER_PROGRESS.SEXUAL_ENVIRONMENT:
        return PATHS.SEXUAL_ENVIRONMENT;
      case MEMBER_PROGRESS.EVENT_ATTRACT:
        return PATHS.EVENT_ATTRACT;
      case MEMBER_PROGRESS.ALCOHOL_CANNABIS:
        return PATHS.ALCOHOL_CANNABIS;
      case MEMBER_PROGRESS.BE_MATCHED:
        return PATHS.BE_MATCHED;
      case MEMBER_PROGRESS.JOIN_HOST:
        return PATHS.JOIN_HOST;
      case MEMBER_PROGRESS.REAL_IMAGE:
        return PATHS.REAL_IMAGE;
      case MEMBER_PROGRESS.SOCIAL:
        return PATHS.SOCIAL;
      case MEMBER_PROGRESS.PAYMENT:
        return PATHS.PAYMENT;
      case MEMBER_PROGRESS.PENDING:
        return PATHS.PENDING;
      case MEMBER_PROGRESS.APPROVED:
        return PATHS.APPROVED;
      default:
        return PATHS.MEMBER_CHOOSE_TYPE;
    }
  }

  return PATHS.LOGIN;
}
